import { useState, useEffect } from "react";
import { ArrowUp } from "lucide-react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      data-testid="back-to-top-btn"
      aria-label="Nach oben"
      className="fixed bottom-24 left-5 z-40 w-10 h-10 flex items-center justify-center bg-hb-dark text-white hover:bg-hb-yellow hover:text-hb-dark transition-all duration-200 shadow-lg"
      style={{ border: "1px solid rgba(255,255,255,0.1)" }}
    >
      <ArrowUp size={15} />
    </button>
  );
}
